import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Icon, Image } from "@atoms";
import { Item, Card } from "@molecules";
import { SideBarLogicInterface } from "./logic";
import { usePartnerUtils } from "../../../../utils/partner-utils"; // todo: implement @ pathing
import { localEnv, isProductionBetaVersion } from "@config";
import { Input } from "@atoms/input";

export type SideBarTemplateProps = SideBarLogicInterface;

export const SideBarTemplate = ({
  menuItems,
  signOut,
  selectedPageIndex,
  navigateToPage,
}: SideBarTemplateProps): JSX.Element => {
  const { isSectionIncomplete } = usePartnerUtils();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language?.split("-")?.[0] || "en";

  const languageOptions = useMemo(
    () => [
      { value: "en", label: "English" },
      { value: "fr", label: "Français" },
    ],
    [],
  );

  const selectedLanguageOption =
    languageOptions.find((option) => option.value === currentLanguage) ?? languageOptions[0];

  const handleLanguageChange = (option: any) => {
    if (!option?.value) return;
    i18n.changeLanguage(option.value);
  };

  return (
    <div className="flex flex-col justify-between w-full h-screen min-h-screen px-4 pt-6 bg-white">
      <div className=""> 
        <div className="mt-4 mb-16 ml-3">
          <Image variant="parachuteLogoWithText" width={160} height={39} />
        </div>
        {/* {localEnv === "dev" ?
          <div className="text-center bg-primary-medium text-white">
            {"DEV VERSION"}
          </div>
          :
          isProductionBetaVersion &&
            <div className="text-center bg-primary-light text-secondary-dark">
              {"BETA VERSION"}
            </div>         
        } */}
        <div>
          {menuItems.map(({ labelKey, to, icon }, index) => (
            <div key={index} className="mt-1">
              <Item
                variant="sidebar"
                icon={<Icon {...icon} width={20} height={20} size={20} />}
                label={t(labelKey)}
                onClick={() => {
                  navigateToPage(index, to)}
                }
                selected={selectedPageIndex !== undefined && selectedPageIndex === index ? true : false}
                isSectionIncomplete={isSectionIncomplete(to)}
              />
            </div>
          ))}
          <div key={"sign-out"} className="pt-1">
            <Item
              variant="sidebar"
              icon={<Icon variant="signOut" size={24} />}
              label={t("nav.signOut")}
              onClick={() => signOut?.()}
              selected={false}
              isSectionIncomplete={false}
            />
          </div>
        </div>
      </div>
      <div className="pb-8">
        <div className="mb-4">
          <label className="block text-xs text-neutral-dark mb-1">
            {t("common.language")}
          </label>
          <div className="min-w-[180px]">
            <Input
              key={`sidebar-language-${currentLanguage}`}
              name="sidebar-language"
              type="languageDropdown"
              variant="dropdown"
              options={languageOptions}
              onChange={handleLanguageChange}
              placeholder={selectedLanguageOption}
              value={currentLanguage}
              errorMessage={undefined}
            />
          </div>
        </div>
        <Card variant="userInfo" onClick={() => {}} />
      </div>
    </div>
  );
};
